import axios from 'axios';

if (!import.meta.env.VITE_APP_MAP_URL || !import.meta.env.VITE_APP_MAP_API_KEY) {
  throw new Error('ABMI API Env not set: VITE_APP_MAP_URL, VITE_APP_MAP_API_KEY');
}
const abmiApiUrl = import.meta.env.VITE_APP_MAP_URL;
const headers = {
  'X-API-Key': import.meta.env.VITE_APP_MAP_API_KEY
};

const abmiAxios = axios.create({
  baseURL: abmiApiUrl,
  headers
});
/* get detailed layer information for a single layer: color, dataset, name, etc */
export async function loadLayerData (id, isAOI) {
  const apiFct = `layers/${id}?type=${isAOI ? 'aoi' : 'dataset'}&gridId=1&id=${id}`;
  try {
    const responseBody = await abmiAxios.get(apiFct, { headers });
    const baseLayer = responseBody.data.data;
    return baseLayer;
  } catch (error) {
    console.error(error);
  }
  return null;
}
/* get all layers (occurrence, current/reference/difference) for a single species.
*/
export async function getSpeciesLayers (tsn, dataType) {
  const apiFct = 'search-species-maps';
  try {
    const responseBody = await abmiAxios.get(apiFct, { headers, params: { id: tsn, dataType } });
    const baseLayer = responseBody.data.data;
    return baseLayer;
  } catch (error) {
    console.error(error);
  }
  return null;
}
/* retrieve the osr hf layers (enenger layers), by input year */
export async function getOSRHFLayerIds (year) {
  const apiFct = `external/osr-report-layers/${year}`;
  try {
    const responseBody = await abmiAxios.get(apiFct, { headers });
    const layers = responseBody.data.data;
    return layers;
  } catch (error) {
    console.error(error);
  }
  return null;
}

/* get the area summary for given boundary id and datasetIds */
export async function getAreaSummary (boundaryId, datasetIds) {
  const apiFct = `layers/${boundaryId}/summaries`;
  try {
    const responseBody = await abmiAxios.get(apiFct, { headers, params: { id: boundaryId, datasetIds: datasetIds.join(',') }  });
    const data = responseBody.data.data;
    return data;
  } catch (error) {
    console.error(error);
  }
  return null;
}

const abmiApi = {
  getSpeciesLayers,
  loadLayerData

};

export default abmiApi;
